/**
 * Tipos das Cobranças Administrativas do Portal do Credenciado.
 *
 * Cobrança administrativa é o DAMSP emitido por um serviço prestado pela SMT
 * a pedido do credenciado (substituição de condutor, revisão de bancada,
 * vistoria extraordinária etc.), distinta de multa. Sem
 * `docs/MODELO-DE-DADOS.md` para esta tabela ainda (não existe no banco): os
 * campos aqui nascem do protótipo e do bom senso, não de migração.
 */

export type StatusDaCobranca =
  'pendente' | 'aguardando_pagamento' | 'paga' | 'vencida' | 'parcelada' | 'cancelada';

export type TipoDeServicoCobrado =
  | 'substituicao_condutor'
  | 'substituicao_monitor'
  | 'substituicao_veiculo'
  | 'revisao_bancada'
  | 'vistoria_creche'
  | 'troca_dre'
  | 'inclusao_veiculo'
  | 'recurso_administrativo';

export const ROTULO_DO_TIPO_DE_SERVICO: Record<TipoDeServicoCobrado, string> = {
  substituicao_condutor: 'Substituição de condutor',
  substituicao_monitor: 'Substituição de monitor',
  substituicao_veiculo: 'Substituição de veículo',
  revisao_bancada: 'Revisão de bancada',
  vistoria_creche: 'Vistoria de creche',
  troca_dre: 'Troca de DRE',
  inclusao_veiculo: 'Inclusão de veículo',
  recurso_administrativo: 'Recurso administrativo',
};

export interface CobrancaAdministrativa {
  id: string;
  /** Número do DAMSP emitido, ex. "DAMSP 2026/00147". */
  numero: string;
  motivo: string;
  tipoServico: TipoDeServicoCobrado;
  valor: number;
  /** Data de vencimento, formato ISO ("2026-09-10"). */
  vencimento: string;
  status: StatusDaCobranca;
}

/** Filtro da listagem de cobranças. A paginação é sempre do servidor. */
export interface FiltroDeCobrancas {
  pagina: number;
  tamanho: number;
  /** Texto livre, combina com `motivo` ou `numero`. */
  busca?: string;
  tipoServico?: TipoDeServicoCobrado;
  status?: StatusDaCobranca;
  /** Data de vencimento inicial, formato ISO. */
  vencimentoDe?: string;
  /** Data de vencimento final, formato ISO. */
  vencimentoAte?: string;
}

export const TAMANHO_PAGINA_PADRAO = 10;
